import { useMemo } from 'react';
import { useListSubmissionsBySite } from 'api/resource';
import { SubmissionStatus } from 'interfaces/submission';

export const useIsGeneratingSubmission = ({ siteID }: { siteID: string }) => {
  const {
    data: submissions,
    refetch,
    isFetching,
  } = useListSubmissionsBySite({
    siteID: siteID,
    displayNotification: false,
    refetchInterval: 120000, // 2 minutes
  });

  const isGenerating = useMemo(() => {
    if (!submissions) return false;
    return submissions.some(
      (submission) => submission.status === SubmissionStatus.generating
    );
  }, [submissions]);

  return { isGenerating, refetch, isFetching };
};
